import { useFadeIn } from '@/hooks/useFadeIn';

const cases = [
  {
    id: 1,
    title: '症例1：上下の前歯の叢生（ガタガタ）',
    treatment: 'マウスピース矯正（ELINESMILE/自由診療）',
    period: '約8ヶ月・11回',
    cost: '198,500円（税込）',
    description:
      '上下の歯が重なり合い、清掃不良による虫歯リスクが高い状態でした。マウスピース矯正により、歯を抜かずに美しい歯並びを実現しました。',
    before: 'https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/322cd87c636932d9f178bcb1fc4947fc.jpeg',
    after: 'https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/b8c39332ec42540425f80a099743bd45.jpeg',
    disclaimer:
      '矯正治療特有の痛みや違和感が生じる場合があります。適切な装着時間を守らないと計画通りに歯が動かない、あるいは治療期間が延びることがあります。また、治療完了後には後戻りを防ぐための保定装置（リテーナー）の装着が必要です。まれに歯根吸収や歯肉退縮が起こる可能性があります。この症例は個人の結果であり、すべての方に同様の効果を保証するものではありません。重度の骨格的問題・歯周病が進行している方・顎関節症の方など、適応外となる場合があります。詳しくはカウンセリングにてご確認ください。',
  },
  {
    id: 2,
    title: '症例2：クロスバイト（交差咬合）',
    treatment: 'マウスピース矯正（ELINESMILE／自由診療）',
    period: '約11ヶ月・9回',
    cost: '440,000円（税込）',
    description:
      '左の前から2番目の歯が交差咬合で、口元のコンプレックスとなっていた症例です。マウスピース矯正で、口元のバランスを整えました。',
    before: 'https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/3b55e7f9325fb5029312e0c1df830bf1.jpeg',
    after: 'https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/0c0354c6b6cf562ba48560200925d97a.jpeg',
    disclaimer:
      '矯正治療特有の痛みや違和感が生じる場合があります。適切な装着時間を守らないと計画通りに歯が動かない、あるいは治療期間が延びることがあります。また、治療完了後には後戻りを防ぐための保定装置（リテーナー）の装着が必要です。まれに歯根吸収や歯肉退縮が起こる可能性があります。この症例は個人の結果であり、すべての方に同様の効果を保証するものではありません。重度の骨格的問題・歯周病が進行している方・顎関節症の方など、適応外となる場合があります。詳しくはカウンセリングにてご確認ください。',
  },
  {
    id: 3,
    title: '症例3：重度の捻転・叢生（ねじれ・ガタガタ）',
    treatment: 'マウスピース矯正（ELINESMILE／自由診療）',
    period: '約17ヶ月・15回',
    cost: '440,000円（税込）',
    description:
      '前歯を中心に重度のねじれやガタガタ（叢生）が目立つ状態でした。マウスピース矯正により、自然で美しい歯並びに改善しました。',
    before: 'https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/06971941247b9f83681a96f3b4762f45.jpeg',
    after: 'https://static.readdy.ai/image/cff737b9fe944b0ea10e9e46c08321bb/bb2678a6d9e41c974caf538ea1a2a03e.jpeg',
    disclaimer:
      '矯正治療特有の痛みや違和感が生じる場合があります。適切な装着時間を守らないと計画通りに歯が動かない、あるいは治療期間が延びることがあります。また、治療完了後には後戻りを防ぐための保定装置（リテーナー）の装着が必要です。まれに歯根吸収や歯肉退縮が起こる可能性があります。この症例は個人の結果であり、すべての方に同様の効果を保証するものではありません。重度の骨格的問題・歯周病が進行している方・顎関節症の方など、適応外となる場合があります。詳しくはカウンセリングにてご確認ください。',
  },
];

export default function MouthpieceCaseStudies() {
  const heading = useFadeIn({ direction: 'up' });
  const card1 = useFadeIn({ direction: 'up', delay: 100 });
  const card2 = useFadeIn({ direction: 'up', delay: 200 });
  const card3 = useFadeIn({ direction: 'up', delay: 300 });
  const refs = [card1, card2, card3];

  return (
    <section className="py-32 md:py-40 px-6 bg-white">
      <div className="max-w-5xl mx-auto space-y-20">
        {/* Heading */}
        <div ref={heading.ref} style={heading.style} className="text-center space-y-4">
          <p className="text-xs tracking-[0.2em] text-gray-400 uppercase">Case Studies</p>
          <h2
            className="text-2xl md:text-3xl font-normal text-gray-900 leading-relaxed tracking-wide font-serif"
          >
            症例紹介
          </h2>
          <p className="text-sm text-gray-500 font-light leading-loose max-w-xl mx-auto">
            実際の治療症例をご紹介します。<br />
            個人差がありますので、詳細はカウンセリングにてご確認ください。
          </p>
        </div>

        {/* Cases */}
        <div className="space-y-24">
          {cases.map((c, i) => (
            <div
              key={c.id}
              ref={refs[i].ref}
              style={refs[i].style}
              className="space-y-8"
            >
              {/* Case title */}
              <div className="flex items-center gap-4">
                <span className="text-2xl font-light text-gray-300">0{c.id}</span>
                <h3 className="text-lg md:text-xl font-normal text-gray-900 tracking-wide font-serif">
                  {c.title}
                </h3>
              </div>

              {/* Before / After images */}
              <div className="grid grid-cols-2 gap-4 md:gap-6">
                {/* Before */}
                <div className="space-y-2 group cursor-pointer">
                  <div className="relative w-full aspect-[5/4] overflow-hidden rounded-lg bg-gray-100">
                    <img
                      src={c.before}
                      alt={`${c.title} Before`}
                      className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                      style={{ filter: 'brightness(1.15)' }}
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-500 ease-out" />
                    <span className="absolute top-2 left-2 md:top-3 md:left-3 text-[10px] md:text-xs font-medium tracking-widest px-2 py-0.5 md:px-3 md:py-1 rounded-full transition-all duration-300 group-hover:scale-105 group-hover:shadow-lg text-white" style={{ backgroundColor: '#3E5F8F' }}>
                      BEFORE
                    </span>
                  </div>
                </div>

                {/* After */}
                <div className="space-y-2 group cursor-pointer">
                  <div className="relative w-full aspect-[5/4] overflow-hidden rounded-lg bg-gray-100">
                    <img
                      src={c.after}
                      alt={`${c.title} After`}
                      className="w-full h-full object-cover object-top transition-transform duration-700 ease-out group-hover:scale-105"
                      style={{ filter: 'brightness(1.15)' }}
                    />
                    <div className="absolute inset-0 bg-[#3E5F8F]/0 group-hover:bg-[#3E5F8F]/15 transition-all duration-500 ease-out" />
                    <span className="absolute top-2 left-2 md:top-3 md:left-3 text-[10px] md:text-xs font-medium tracking-widest px-2 py-0.5 md:px-3 md:py-1 bg-white rounded-full transition-all duration-300 group-hover:scale-105 group-hover:shadow-lg" style={{ color: '#3E5F8F' }}>
                      AFTER
                    </span>
                  </div>
                </div>
              </div>

              {/* Description & info */}
              <div className="space-y-5 bg-gray-50 rounded-lg p-6 md:p-8">
                <p className="text-gray-700 text-sm md:text-base font-light leading-loose">
                  {c.description}
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-2">
                  <div className="space-y-1">
                    <p className="text-xs text-gray-400 tracking-widest">治療名</p>
                    <p className="text-sm text-gray-800 font-light">{c.treatment}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-xs text-gray-400 tracking-widest">治療期間・回数</p>
                    <p className="text-sm text-gray-800 font-light">{c.period}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-xs text-gray-400 tracking-widest">費用目安</p>
                    <p className="text-sm text-gray-800 font-light">{c.cost}</p>
                  </div>
                </div>
                <p className="text-xs text-gray-400 font-light leading-relaxed border-t border-gray-200 pt-4">
                  {c.disclaimer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
